// extracted by mini-css-extract-plugin
module.exports = {"mobile":"640","tablet":"1024","desktop":"1920"};